import React, { Component } from 'react'
import headshotImg from "./imgs/mikeycompressed.jpg"
import "./About.scss"

export default class About extends Component {
    render() {
        return (
            <div className="About my-5" id="about">
                <img className="About-headshot" src={headshotImg} alt="Michael's Headshot"></img>
                <h1 className="text-primary m-5">Why I Program</h1>
                <div className="container-md">
                    <p className="mx-5">It all started in high school with C#. This is where I fell in love with creating projects and being able to see changes visually. This drew me to front end and
                        UX
                        work. From there, I tried college and realized it wasn't my learning style. Although, I was able to
                        jumpstart
                        my career as a SAS intern. In order to be successful at this internship, I taught myself Angular.
                        After leaving school, I pursued my own businesses and investing. I eventually landed at NuCamp
                        Coding Bootcamp. I am set to graduate in Sept. '21. I love to push myself by
                        continually learning and trying to master my craft. That's why I have been pursuing courses on
                        Udemy,
                        freeCodeCamp and The Odin Project. With the completion of the NuCamp React Course, I am looking to pursue a futher career in web development.</p>
                </div>
            </div>
        )
    }
}
